import { useCallback, useEffect, useState } from "react";
import classes from "./Captcha.module.scss";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    grecaptcha: any;
    onloadCaptchaCallback: () => void;
  }
}

interface IProps {
  id: string;
  onSuccess: (token: string) => void;
  onFailed: () => void;
  onRendered: (reset: () => void) => void;
}

const Captcha = ({ id, onSuccess, onFailed, onRendered }: IProps) => {
  const [widgetId, setWidgetId] = useState(null);
  const [isError, setIsError] = useState(false);

  const render = useCallback(() => {
    try {
      const identity = window.grecaptcha.render(id, {
        sitekey: process.env.REACT_APP_CAPTCHA_KEY ?? "",
        theme: "light",
        callback: onSuccess,
        "expired-callback": onFailed,
        "error-callback": onFailed
      });

      setWidgetId(identity);

      const reset = () => {
        window.grecaptcha.reset(
          identity
        );
      };

      onRendered(reset);
    } catch (e) {
      console.warn(e);
      setIsError(true);
    }
  }, [id, onSuccess, onFailed, onRendered]);

  useEffect(() => {
    if (!window.grecaptcha) {
      window.onloadCaptchaCallback = render;
      loadScript();
    } else if (widgetId === null) {
      render();
    }
  }, [widgetId, render]);

  return (
    <div className={classes.captcha}>
      <div id={id} />
      {
        isError && (
          <div className={classes.error}>
            Sorry could not load captcha, please refresh the page.<br/>
            If that doesn't help, try to disable your ad blocker.
          </div>
        )
      }
    </div>
  );
};

const loadScript = () => {
  const js = document.createElement("script");

  js.async = true;
  js.defer = true;
  js.src = "https://www.google.com/recaptcha/api.js?onload=onloadCaptchaCallback&render=explicit";

  document.head.appendChild(js);
};

export default Captcha;
